/**
 * Rotate a base64 image by 90° clockwise using an offscreen canvas.
 *
 * @param {string} base64Src - Base64 data URI of the image
 * @returns {Promise<string>} Rotated base64 PNG
 */
export function rotateImage90(base64Src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.height;
      canvas.height = img.width;
      const ctx = canvas.getContext("2d");
      ctx.translate(canvas.width, 0);
      ctx.rotate(Math.PI / 2);
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };
    img.src = base64Src;
  });
}

/**
 * Crop a region from an image element using canvas.
 * Maps screen coordinates to the image's natural dimensions for OCR-quality output.
 *
 * L'échelle se calcule sur la taille AFFICHÉE de l'image elle-même, jamais sur celle
 * de son conteneur : quand l'image est plus petite que le calque de sélection, la zone
 * rognée est décalée et agrandie, et chaque champ embarque son voisin de droite — sur
 * une carte grise, c'est une date (« /2014 » en bout d'immatriculation, mesuré 2026-09-18).
 *
 * @param {HTMLImageElement} imgElement - The displayed image element
 * @param {{ x: number, y: number, w: number, h: number }} rect - Selection rectangle, relative to the image's displayed box
 * @returns {string} Base64 PNG of the cropped region
 */
export function cropImage(imgElement, rect) {
  const shown = imgElement.getBoundingClientRect();
  const scaleX = imgElement.naturalWidth / shown.width;
  const scaleY = imgElement.naturalHeight / shown.height;
  const canvas = document.createElement("canvas");
  canvas.width = rect.w * scaleX;
  canvas.height = rect.h * scaleY;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(
    imgElement,
    rect.x * scaleX,
    rect.y * scaleY,
    rect.w * scaleX,
    rect.h * scaleY,
    0, 0,
    canvas.width,
    canvas.height
  );
  return canvas.toDataURL("image/png");
}
